import React from 'react'
import PropTypes from 'prop-types'
import { Loader, Copy } from '@elparking/components'

import connectUrl from 'commons/js/components/connectUrl'
import { compactObject } from 'commons/js/util/objectUtils'
import { toUrlSearchParams } from 'commons/js/util/UrlTo'

function buildFilteredSearchParams (params) {
    // NOTE: Params will be serialized in this order (ej. ?place_id=1&start_date=2020-01-01T00:00...)
    return compactObject({
        place_id: params.placeId,
        airport_id: params.airportId,
        poi_id: params.poiId,
        start_date: params.startDate,
        end_date: params.endDate,
        duration: params.duration,
        start_date_offset: params.startDateOffset,
    })
}

class LocationDetector extends React.PureComponent {
    static propTypes = {
        component: PropTypes.elementType,
        geocodePlace: PropTypes.func,
        defaultParams: PropTypes.shape({
            place_id: PropTypes.string,
        }),
        search: PropTypes.shape({
            placeId: PropTypes.string,
            airportId: PropTypes.string,
            poiId: PropTypes.string,
            latitude: PropTypes.number,
            longitude: PropTypes.number,
        }),
        otherUrlParams: PropTypes.object,
        // From Router
        location: PropTypes.object,
        history: PropTypes.object,
        match: PropTypes.object,
        showFilterBox: PropTypes.bool.isRequired,
    }

    static defaultProps = {
        defaultParams: {},
    }

    state = {
        placeId: this.props.search.placeId,
    }

    async findPlaceIdByLatitudeLongitude (latLong) {
        let geoResult
        try {
            geoResult = await this.props.geocodePlace(latLong)
        } catch (e) {
            this.setDefaultPlaceId()
        }

        // TODO: Can this really happen?
        if (geoResult) {
            this.setState({ placeId: geoResult['place_id'] })
        } else {
            this.setDefaultPlaceId()
        }
    }

    setDefaultPlaceId () {
        this.setState({placeId: this.props.defaultParams['place_id']})
    }

    setPlaceIdBasedOnAvailableParams = this.setPlaceIdBasedOnAvailableParams.bind(this)

    setPlaceIdBasedOnAvailableParams (lat, long, isIdDefined) {
        if (lat && long) {
            const latLng = {latitude: lat, longitude: long}
            this.findPlaceIdByLatitudeLongitude(latLng)
        } else if (!isIdDefined) {
            this.setDefaultPlaceId()
        }
    }

    componentDidMount () {
        if (!this.state.placeId) {
            const { latitude, longitude, airportId, poiId } = this.props.search
            const isIdDefined = airportId || poiId
            this.setPlaceIdBasedOnAvailableParams(latitude, longitude, isIdDefined)
        }
    }

    componentDidUpdate (_, prevState) {
        if (prevState.placeId !== this.state.placeId) {
            const searchParams = buildFilteredSearchParams({
                ...this.props.search,
                // Overwrite placeId with the one already resolved
                placeId: this.state.placeId,
            })

            this.props.history.push(`?${toUrlSearchParams({
                ...this.props.otherUrlParams,
                ...searchParams,
            })}`)
        }
    }

    renderLoader () {
        return (
            <Copy align='center' padding='20px'>
                <Loader size='20px' />
            </Copy>
        )
    }

    render () {
        const { search, component: ContainerComponent, showFilterBox } = this.props
        const { placeId, airportId, poiId } = search
        const shouldResolveLocation = !placeId && !airportId && !poiId

        if (shouldResolveLocation) {
            return this.renderLoader()
        }

        return (
            <ContainerComponent
              location={this.props.location}
              match={this.props.match}
              history={this.props.history}
              placeId={placeId}
              airportId={airportId}
              poiId={poiId}
              showFilterBox={showFilterBox}
            />
        )
    }
}

const parseValue = (value) => value === 'null' ? null : value || null

function mapParamsToProps (_, searchParams) {
    const {
        start_date: startDate,
        end_date: endDate,
        duration,
        start_date_offset: startDateOffset,
        place_id: placeId,
        airport_id: airportId,
        poi_id: poiId,
        latitude,
        longitude,
        ...otherUrlParams
    } = searchParams
    return {
        search: {
            startDate,
            endDate,
            duration,
            startDateOffset,
            placeId: parseValue(placeId),
            airportId: parseValue(airportId),
            poiId: parseValue(poiId),
            latitude: parseFloat(latitude) || null,
            longitude: parseFloat(longitude) || null,
        },
        otherUrlParams,
    }
}

export default connectUrl(mapParamsToProps)(LocationDetector)
